// extracted by mini-css-extract-plugin
export default {"view":"J4zxW","appear-from-above":"Y_0_a","appearFromAbove":"Y_0_a"};